// extracted by mini-css-extract-plugin
module.exports = {"loadingIcon":"_loading_loadingIcon_25hDh"};